module.exports = require("@swa-ui/core/src/Card/Card.module.scss");